export default __webpack_public_path__ + "static/media/BY.1525f700.svg";